import { RunStatus } from '../../../../backend/src/types/types';

export type ProcessingStatus = Extract<
  RunStatus,
  | RunStatus.InQueue
  | RunStatus.Parsing
  | RunStatus.AwaitingApproval
  | RunStatus.Extracting
  | RunStatus.Clustering
  | RunStatus.IdentifyingRelevance
  | RunStatus.IdentifyingInconsistencies
  | RunStatus.Summarising
>;

export const PipelineProcessingStageDescriptions: Record<
  ProcessingStatus,
  { title: string; subTitle: string; description: string; weight: number }
> = {
  [RunStatus.InQueue]: {
    title: 'Queuing Documents',
    subTitle: 'In Queue...',
    description: 'Documents are added to the queue for processing.',
    weight: 0,
  },
  [RunStatus.Parsing]: {
    title: 'Calculating Page Count',
    subTitle: 'Calculating pages and completion time.',
    description: 'Documents are converted into parsable pages, and an estimated completion time is calculated.',
    weight: 1,
  },
  [RunStatus.AwaitingApproval]: {
    title: 'Approval',
    subTitle: '',
    description: 'Approve or cancel this run before processing continues',
    weight: 0,
  },
  [RunStatus.Extracting]: {
    title: 'Extracting Facts',
    subTitle: 'Extracting facts...',
    description: 'OCR is performed on documents before facts are identified and extracted.',
    weight: 6,
  },
  [RunStatus.Clustering]: {
    title: 'Clustering Facts',
    subTitle: 'Clustering Facts...',
    description: 'Facts expressing the same event are merged together to avoid duplicate facts.',
    weight: 2,
  },
  [RunStatus.IdentifyingRelevance]: {
    title: 'Classifying Relevance',
    subTitle: 'Identifying Relevance...',
    description:
      'Each fact is evaluated against the Matter context to assess its individual relevance and significance.',
    weight: 4,
  },
  [RunStatus.IdentifyingInconsistencies]: {
    title: 'Identifying Inconsistencies',
    subTitle: 'Identifying Inconsistencies...',
    description:
      'Semantically similar facts are compared to find inconsistencies, and evaluated against the Matter issues to determine severity.',
    weight: 2,
  },
  [RunStatus.Summarising]: {
    title: 'Finalising Generation',
    subTitle: 'Generating Summary...',
    description:
      'Key entities are identified and mapped to facts. Summaries are generated for both the Matter and individual issues.',
    weight: 1,
  },
};

export const PipelineProcessingStages = Object.keys(PipelineProcessingStageDescriptions) as ProcessingStatus[];

export const isProcessingStatus = (status: RunStatus): status is ProcessingStatus => {
  return PipelineProcessingStages.includes(status as ProcessingStatus);
};
